import { Monitor, Moon, Sun } from "lucide-react";

import { Button } from "../components/ui/button";
import { useUiStore, type ThemePreference } from "../store/uiStore";

const NEXT: Record<ThemePreference, ThemePreference> = {
  light: "dark",
  dark: "system",
  system: "light",
};

const ICON = { light: Sun, dark: Moon, system: Monitor };

/** Cycles the device-local theme preference: light → dark → system. */
export function ThemeToggle({ className }: { className?: string }) {
  const theme = useUiStore((s) => s.theme);
  const setTheme = useUiStore((s) => s.setTheme);
  const Icon = ICON[theme];

  return (
    <Button
      variant="ghost"
      size="icon"
      className={className}
      aria-label={`Theme: ${theme}. Switch to ${NEXT[theme]}.`}
      title={`Theme: ${theme}`}
      onClick={() => setTheme(NEXT[theme])}
    >
      <Icon className="size-4" />
    </Button>
  );
}
